export const AUTH_CONFIG = {
    domain: "jumpjump.auth0.com",
    clientId: "QIFqdhkrAdM5szdKBhWU74dcFkq5Th38",
    callbackUrl:
        "http://isles-capstone.s3-website.us-east-2.amazonaws.com/callback"
};



// WEBPACK FOOTER //
// ./src/Components/Auth/auth0-variables.js